<div class="page-content">
    <div class="body-data">
        <div class="main">
            <div class="heading">
                <div class="h6">
                    <span class="text-heading">Inspect</span>
                </div>
            </div>

            <div class="content">
                <div class="tabs position-relative">
                    <div class="search custom-form float-end position-absolute">
                        <input type="text" class="search-img" placeholder="Search by Order or Email" (keyup)="applyFilter($event)" #input>
                    </div>
                    <mat-tab-group animationDuration="0ms" disableRipple="true" [selectedIndex]="tabIndex"
                        (selectedTabChange)="onTabChange($event)" class="inspection-tab-label">
                        <mat-tab label="All Sessions">
                            <div class="empty" *ngIf="dataSource?.data?.length===0">
                                <div class="image">
                                    <img class="text-center" src="assets/svg/Icon_No-quotations-yet.svg" alt="">
                                </div>
                                <p class="">Inspections will appear here </p>
                            </div>
                            <div class="table my-3">
                                <mat-table [dataSource]="dataSource" matSort>
                                    <ng-container [matColumnDef]="column.key" *ngFor="let column of displayedColumns">
                                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{column.viewValue |
                                            uppercase}}</mat-header-cell>
                                        <mat-cell *matCellDef="let row">
                                            <div [ngSwitch]="column?.type">
                                                <ng-container *ngSwitchCase="'text'">
                                                    <div [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')"
                                                        *ngIf="isArray(row[column.key]); else nonArrayBlock">
                                                        <ng-container
                                                            *ngIf="column?.avatar?.columnKey === column?.key; else noAvatarBlock">
                                                            <ng-container
                                                                *ngIf="row[column.key]?.length === 1;else multiValue">
                                                                <div>
                                                                    <span
                                                                        *ngFor="let value of row[column.key]; let i=index"
                                                                        class="stackedAvatars d-flex align-items-center">
                                                                        <ngx-avatar [name]="value || 'XYZ'"
                                                                            src="assets/svg/avatar-photo.jpg" size="24"
                                                                            [round]="true">
                                                                        </ngx-avatar>
                                                                        <p class="ps-2 mb-0 word-break">{{value ||
                                                                            'XYZ'}}</p>
                                                                    </span>
                                                                </div>
                                                            </ng-container>
                                                            <ng-template #multiValue>
                                                                <div class="d-flex">
                                                                    <span
                                                                        *ngFor="let value of row[column.key].slice(0, 5); let i=index"
                                                                        class="stackedAvatars"
                                                                        [style.transform]="('translateX(' + (-1 * i * 10) + 'px)')">
                                                                        <ngx-avatar [matTooltip]="value || 'XYZ'"
                                                                            [name]="value || 'XYZ'"
                                                                            src="assets/svg/avatar-photo.jpg" size="24"
                                                                            [round]="true">
                                                                        </ngx-avatar>
                                                                    </span>
                                                                    <span *ngIf="row[column.key]?.length > 5"
                                                                        class="stackedAvatars" [style.transform]="('translateX(' + (-1 * 5 * 10) + 'px)')">
                                                                        <ngx-avatar
                                                                            [name]="'+ '+(row[column.key]?.length - 5).toString()"
                                                                            src="assets/svg/avatar-photo.jpg" size="24"
                                                                            [round]="true">
                                                                        </ngx-avatar>
                                                                    </span>
                                                                </div>
                                                            </ng-template>

                                                        </ng-container>

                                                        <!-- :This block will show string arrays currently-->
                                                        <ng-template #noAvatarBlock>
                                                            <ng-container *ngFor="let value of row[column.key]">
                                                                <div class="w-75" *ngIf="column.key==='docs'">
                                                                    <p class="text-break"> {{value?.part_name}}</p>
                                                                </div>
                                                                <div *ngIf="column.key==='inspectionStatus'">
                                                                    <span class="d-flex gap-1">
                                                                        <p>{{value?.batchName}}: </p>
                                                                        <p [ngClass]="{
                                                                            'blue': value?.inspectionStatus === 'Scheduled',
                                                                            'green': value?.inspectionStatus === 'Passed',
                                                                            'red': value?.inspectionStatus === 'Failed',
                                                                            'orange': value?.inspectionStatus === 'Incomplete'
                                                                        }">
                                                                            {{value?.inspectionStatus}}
                                                                        </p>
                                                                    </span>
                                                                </div>
                                                            </ng-container>
                                                        </ng-template>
                                                    </div>
                                                    <ng-template #nonArrayBlock>
                                                        <div class="d-flex flex-row gap-1 align-items-center">
                                                            <img *ngIf="column?.icon?.columnKey === column?.key && column?.icon?.bShow"
                                                                [src]="column.icon?.imgSrc" alt="icon">
                                                            <span
                                                                [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                                                                {{row[column.key]}}
                                                            </span>
                                                        </div>

                                                    </ng-template>
                                                </ng-container>

                                                <ng-container *ngSwitchCase="'number'">
                                                    <div
                                                        [ngClass]="(column?.classKey === column?.key ? column?.classValue : '')">
                                                        {{row[column.key]}}
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngSwitchCase="'date'">
                                                    <div
                                                        [ngClass]="{'orange':isInspectionYetToHappen(row)}">
                                                        {{row[column.key] | date:'short'}}
                                                    </div>
                                                </ng-container>

                                            </div>
                                        </mat-cell>
                                    </ng-container>

                                    <!-- Action column to show text/svg-icon-img/button -->
                                    <ng-container *ngIf="actionColumn?.bShow" matColumnDef="action">
                                        <mat-header-cell *matHeaderCellDef
                                            class="light-text pl-0">{{actionColumn?.header}}</mat-header-cell>
                                        <mat-cell class="pl-0 d-flex gap-2 flex-column" *matCellDef="let element">
                                            <ng-container
                                                *ngIf="isInspectionYetToHappen(element); else pastActions">
                                                <span [class.disabled]="action.disabled"
                                                    *ngFor="let action of actionColumn.futureActions"
                                                    (click)="futureActionCellClick(element)"
                                                    class="pointer mb-0 d-flex flex-row gap-1">
                                                    <p [matTooltip]="action?.toolTip"
                                                        class="orange text-decoration-underline fw-bold">
                                                        {{action?.title}}</p>
                                                </span>
                                            </ng-container>
                                            <ng-template #pastActions>
                                                <span [class.disabled]="action.disabled"
                                                    *ngFor="let action of actionColumn.pastActions"
                                                    (click)="pastActionCellClick(element)"
                                                    class="pointer mb-0 d-flex flex-row gap-1">
                                                    <p [matTooltip]="action?.toolTip"
                                                        class="link-green text-decoration-underline">
                                                        {{action?.title}}</p>
                                                </span>
                                            </ng-template>
                                        </mat-cell>
                                    </ng-container>

                                    <!-- Header for table -->
                                    <mat-header-row *matHeaderRowDef="columnsDefs"></mat-header-row>
                                    <mat-row *matRowDef="let row; columns: columnsDefs;"></mat-row>
                                    <mat-row *matNoDataRow [hidden]="pageLoad"="let row; columns: columnsDefs;">
                                        <mat-cell class="text-center" [attr.colspan]="displayedColumns.length">
                                            No data matching the filter
                                        </mat-cell>
                                    </mat-row>
                                </mat-table>
                                <mat-paginator #paginator class="d-flex justify-content-center" [length]="total_count"
                                    [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
                                    (page)="paginationChange($event)">
                                </mat-paginator>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
    </div>
</div>